import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  CookieHelperService,
  FlyoutLangSelectConfirmation
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';

@Component({
  selector: 'idp-lang-select-confirmation',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './flyout-lang-select-confirmation.component.html',
  styleUrls: ['./flyout-lang-select-confirmation.component.scss'],
  providers: [CookieHelperService]
})
export class FlyoutLangSelectConfirmationComponent {
  @Input() content: FlyoutLangSelectConfirmation =
    {} as FlyoutLangSelectConfirmation;

  @Input() showModal = true;

  @Output() flyoutLangConfirmed = new EventEmitter<boolean>();
  @Output() openCls = new EventEmitter();
  @Output() closeEvent = new EventEmitter();

  setPrefCookieOnSelect(isPrimarySelected: boolean): void {
    this.flyoutLangConfirmed.emit(isPrimarySelected);
    this.close();
  }

  openCLS(): void {
    this.openCls.emit();
    this.close();
  }

  close(): void {
    this.closeEvent.emit();
  }
}
